import { connect } from 'react-redux';
import { getTeacherBrandName } from '../../api/redux-watson/watson-config-selectors';
import BrandedDocumentTitle from '../core/common/BrandedDocumentTitle';

const mapStateToProps = state => ({
  brandName: getTeacherBrandName(state),
});

export default connect(mapStateToProps)(BrandedDocumentTitle);
